import { useMutation, useQueryClient } from "@tanstack/react-query";
import { plainToClass } from "class-transformer";

import { journeysApi } from "api";
import { IJourney, Journey } from "models/Journey";

const requestUpdateJourney = async (id: number, payload: journeysApi.JourneyUpdate) => {
  const [error, response] = await journeysApi.updateJourney(id, payload);

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useUpdateJourney = () => {
  const queryClient = useQueryClient();

  const requestJourneyMutation = useMutation({
    mutationFn: (params: { id: number; params: journeysApi.JourneyUpdate }) =>
      requestUpdateJourney(params.id, params.params),
    onSuccess: (data: IJourney) => {
      const updatedJourney = plainToClass(Journey, data);

      queryClient.setQueryData(["journey", updatedJourney.id], updatedJourney);
      queryClient.invalidateQueries({ queryKey: ["journeys"] });
    },
  });

  return requestJourneyMutation;
};

export default useUpdateJourney;
